import { useApiClient } from '../../api/useApiClient';

/**
 * Servicio para obtener información de versión de la API.
 * Equivalente a lo que hace el CLI en el comando app-version.
 */
class VersionService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Obtiene la versión de la API desde el endpoint /api/version.
     * @returns {Promise<string>} Versión de la API como string (ej: "1.4.0")
     */
    async getApiVersion() {
        const response = await this.apiClient.get('/api/version');
        return response?.data?.version || 'N/D';
    }
}

export const useVersionService = () => {
    const apiClient = useApiClient();
    return new VersionService(apiClient);
};

export default VersionService;
